"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersionFromTradeId = exports.getVersionFromOfferId = void 0;
const types_1 = require("../../proxy/types");
const utils_1 = require("../../utils");
const getVersionFromOfferId = (offerId, version) => {
    let offerVersion;
    if (version) {
        offerVersion = version;
    }
    else {
        if (offerId.lt(utils_1.START_OFFER_ID)) {
            offerVersion = types_1.Version.V0;
        }
        else {
            offerVersion = types_1.Version.V1;
        }
    }
    return offerVersion;
};
exports.getVersionFromOfferId = getVersionFromOfferId;
const getVersionFromTradeId = (tradeId, version) => {
    let tradeVersion;
    if (version) {
        tradeVersion = version;
    }
    else {
        if (tradeId.lt(utils_1.START_TRADE_ID)) {
            tradeVersion = types_1.Version.V0;
        }
        else {
            tradeVersion = types_1.Version.V1;
        }
    }
    return tradeVersion;
};
exports.getVersionFromTradeId = getVersionFromTradeId;
